/* eslint-disable react/prop-types */
import { useState } from "react";
import "../styles/AlphabetFilter.css";

function AlphabetFilter({ onFilterChange }) {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const [selectedLetter, setSelectedLetter] = useState("all");

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
    if (onFilterChange) {
      onFilterChange(letter);
    }
  };

  return (
    <div className="nav-letters">
      <button
        key="all"
        onClick={() => handleLetterClick("all")}
        className={selectedLetter === "all" ? "active" : ""}
      >
        All
      </button>
      {alphabet.map((letter) => (
        <button
          key={letter}
          onClick={() => handleLetterClick(letter)}
          className={selectedLetter === letter ? "active" : ""}
        >
          {letter}
        </button>
      ))}
    </div>
  );
}

export default AlphabetFilter;
